import * as React from 'react';


const NoteDefs = () => (
    <defs>
        <linearGradient
            id="Gradient_YELLOW_T0"
            gradientUnits="userSpaceOnUse"
            x1="12.6855"
            y1="10.3447"
            x2="239.9544"
            y2="243.563"
        >
            <stop stopColor="#c4b962" offset="0"/>
            <stop stopColor="#e1d370" offset="0.0856"/>
            <stop stopColor="#edde77" offset="0.1371"/>
            <stop stopColor="#fcec7e" offset="0.887"/>
            <stop stopColor="#fded7f" offset="1"/>
        </linearGradient>
        <path
            id="Template_YELLOW_T0"
            d="M0,76.788L0,248.459S143.809,248.459,177.313,248.459S243.942,239.799,243.942,239.799S247.331,215.708,247.331,195.754L247.331,0S94.867,0,57.598,0S8.283,3.763,8.283,3.763L0,76.788z"
            fill="url(#Gradient_YELLOW_T0)"
        />
        <linearGradient
            id="Gradient_PINK_T0"
            gradientUnits="userSpaceOnUse"
            x1="12.6855"
            y1="10.3447"
            x2="239.9544"
            y2="243.563"
        >
            <stop stopColor="#c75f98" offset="0"/>
            <stop stopColor="#e46cb7" offset="0.0856"/>
            <stop stopColor="#f072c2" offset="0.1371"/>
            <stop stopColor="#ff79cd" offset="0.887"/>
            <stop stopColor="#ff7ace" offset="1"/>
        </linearGradient>
        <path
            id="Template_PINK_T0"
            d="M0,76.788L0,248.459S143.809,248.459,177.313,248.459S243.942,239.799,243.942,239.799S247.331,215.708,247.331,195.754L247.331,0S94.867,0,57.598,0S8.283,3.763,8.283,3.763L0,76.788z"
            fill="url(#Gradient_PINK_T0)"
        />
        <linearGradient
            id="Gradient_GREEN_T0"
            gradientUnits="userSpaceOnUse"
            x1="12.6855"
            y1="10.3447"
            x2="239.9544"
            y2="243.563"
        >
            <stop stopColor="#8fb039" offset="0"/>
            <stop stopColor="#a6ca41" offset="0.0856"/>
            <stop stopColor="#afd545" offset="0.1371"/>
            <stop stopColor="#bae249" offset="0.887"/>
            <stop stopColor="#bbe34a" offset="1"/>
        </linearGradient>
        <path
            id="Template_GREEN_T0"
            d="M0,76.788L0,248.459S143.809,248.459,177.313,248.459S243.942,239.799,243.942,239.799S247.331,215.708,247.331,195.754L247.331,0S94.867,0,57.598,0S8.283,3.763,8.283,3.763L0,76.788z"
            fill="url(#Gradient_GREEN_T0)"
        />
        <linearGradient
            id="Gradient_ORANGE_T0"
            gradientUnits="userSpaceOnUse"
            x1="12.6855"
            y1="10.3447"
            x2="239.9544"
            y2="243.563"
        >
            <stop stopColor="#c2802a" offset="0"/>
            <stop stopColor="#df912f" offset="0.0856"/>
            <stop stopColor="#eb9932" offset="0.1371"/>
            <stop stopColor="#faa234" offset="0.887"/>
            <stop stopColor="#fba335" offset="1"/>
        </linearGradient>
        <path
            id="Template_ORANGE_T0"
            d="M0,76.788L0,248.459S143.809,248.459,177.313,248.459S243.942,239.799,243.942,239.799S247.331,215.708,247.331,195.754L247.331,0S94.867,0,57.598,0S8.283,3.763,8.283,3.763L0,76.788z"
            fill="url(#Gradient_ORANGE_T0)"
        />
        <linearGradient
            id="Gradient_YELLOW_T1"
            gradientUnits="userSpaceOnUse"
            x1="2.9502"
            y1="27.9614"
            x2="266.6925"
            y2="246.7729"
        >
            <stop stopColor="#d7c96b" offset="0"/>
            <stop stopColor="#e2d370" offset="0.0557"/>
            <stop stopColor="#edde77" offset="0.1371"/>
            <stop stopColor="#fcec7e" offset="0.6637"/>
            <stop stopColor="#f2e379" offset="1"/>
        </linearGradient>
        <path
            id="Template_YELLOW_T1"
            d="M5.6,130.425C2.055,94.05,0,23.209,0,23.209L245.551,0l24.487,247.537c0,0-119.585,9.021-157.418,12.229c-37.213,3.154-90.646,13.212-90.646,13.212S9.144,166.799,5.6,130.425z"
            fill="url(#Gradient_YELLOW_T1)"
        />
        <linearGradient
            id="Gradient_PINK_T1"
            gradientUnits="userSpaceOnUse"
            x1="2.9502"
            y1="27.9614"
            x2="266.6925"
            y2="246.7729"
        >
            <stop stopColor="#da67b4" offset="0"/>
            <stop stopColor="#e56cbe" offset="0.0557"/>
            <stop stopColor="#f072c2" offset="0.1371"/>
            <stop stopColor="#ff79cd" offset="0.6637"/>
            <stop stopColor="#f575c4" offset="1"/>
        </linearGradient>
        <path
            id="Template_PINK_T1"
            d="M5.6,130.425C2.055,94.05,0,23.209,0,23.209L245.551,0l24.487,247.537c0,0-119.585,9.021-157.418,12.229c-37.213,3.154-90.646,13.212-90.646,13.212S9.144,166.799,5.6,130.425z"
            fill="url(#Gradient_PINK_T1)"
        />
        <linearGradient
            id="Gradient_GREEN_T1"
            gradientUnits="userSpaceOnUse"
            x1="2.9502"
            y1="27.9614"
            x2="266.6925"
            y2="246.7729"
        >
            <stop stopColor="#a0c13e" offset="0"/>
            <stop stopColor="#a8cb41" offset="0.0557"/>
            <stop stopColor="#afd545" offset="0.1371"/>
            <stop stopColor="#bae249" offset="0.6637"/>
            <stop stopColor="#b2d947" offset="1"/>
        </linearGradient>
        <path
            id="Template_GREEN_T1"
            d="M5.6,130.425C2.055,94.05,0,23.209,0,23.209L245.551,0l24.487,247.537c0,0-119.585,9.021-157.418,12.229c-37.213,3.154-90.646,13.212-90.646,13.212S9.144,166.799,5.6,130.425z"
            fill="url(#Gradient_GREEN_T1)"
        />
        <linearGradient
            id="Gradient_ORANGE_T1"
            gradientUnits="userSpaceOnUse"
            x1="2.9502"
            y1="27.9614"
            x2="266.6925"
            y2="246.7729"
        >
            <stop stopColor="#d5892c" offset="0"/>
            <stop stopColor="#e0902e" offset="0.0557"/>
            <stop stopColor="#eb9932" offset="0.1371"/>
            <stop stopColor="#faa234" offset="0.6637"/>
            <stop stopColor="#f09c33" offset="1"/>
        </linearGradient>
        <path
            id="Template_ORANGE_T1"
            d="M5.6,130.425C2.055,94.05,0,23.209,0,23.209L245.551,0l24.487,247.537c0,0-119.585,9.021-157.418,12.229c-37.213,3.154-90.646,13.212-90.646,13.212S9.144,166.799,5.6,130.425z"
            fill="url(#Gradient_ORANGE_T1)"
        />
        <linearGradient
            id="Gradient_YELLOW_T2"
            gradientUnits="userSpaceOnUse"
            x1="146.3677"
            y1="10.5117"
            x2="126.2828"
            y2="256.6924"
        >
            <stop stopColor="#d4c86a" offset="0"/>
            <stop stopColor="#e2d471" offset="0.0633"/>
            <stop stopColor="#edde77" offset="0.1371"/>
            <stop stopColor="#fcec7e" offset="0.887"/>
            <stop stopColor="#fded7f" offset="1"/>
        </linearGradient>
        <path
            id="Template_YELLOW_T2"
            d="M22.972,0L268.434,18.936,253.83,264.771,1.19,247.699z"
            fill="url(#Gradient_YELLOW_T2)"
        />
        <linearGradient
            id="Gradient_PINK_T2"
            gradientUnits="userSpaceOnUse"
            x1="146.3677"
            y1="10.5117"
            x2="126.2828"
            y2="256.6924"
        >
            <stop stopColor="#d766a4" offset="0"/>
            <stop stopColor="#e56db8" offset="0.0633"/>
            <stop stopColor="#f072c2" offset="0.1371"/>
            <stop stopColor="#ff79cd" offset="0.887"/>
            <stop stopColor="#ff7ace" offset="1"/>
        </linearGradient>
        <path
            id="Template_PINK_T2"
            d="M22.972,0L268.434,18.936,253.83,264.771,1.19,247.699z"
            fill="url(#Gradient_PINK_T2)"
        />
        <linearGradient
            id="Gradient_GREEN_T2"
            gradientUnits="userSpaceOnUse"
            x1="146.3677"
            y1="10.5117"
            x2="126.2828"
            y2="256.6924"
        >
            <stop stopColor="#9abe3e" offset="0"/>
            <stop stopColor="#a7cb42" offset="0.0633"/>
            <stop stopColor="#afd545" offset="0.1371"/>
            <stop stopColor="#bae249" offset="0.887"/>
            <stop stopColor="#bbe34a" offset="1"/>
        </linearGradient>
        <path
            id="Template_GREEN_T2"
            d="M22.972,0L268.434,18.936,253.83,264.771,1.19,247.699z"
            fill="url(#Gradient_GREEN_T2)"
        />
        <linearGradient
            id="Gradient_ORANGE_T2"
            gradientUnits="userSpaceOnUse"
            x1="146.3677"
            y1="10.5117"
            x2="126.2828"
            y2="256.6924"
        >
            <stop stopColor="#d28a2d" offset="0"/>
            <stop stopColor="#e09230" offset="0.0633"/>
            <stop stopColor="#eb9932" offset="0.1371"/>
            <stop stopColor="#faa234" offset="0.887"/>
            <stop stopColor="#fba335" offset="1"/>
        </linearGradient>
        <path
            id="Template_ORANGE_T2"
            d="M22.972,0L268.434,18.936,253.83,264.771,1.19,247.699z"
            fill="url(#Gradient_ORANGE_T2)"
        />
        <linearGradient
            id="Gradient_YELLOW_T3a"
            gradientUnits="userSpaceOnUse"
            x1="199.485"
            y1="229.635"
            x2="204.921"
            y2="244.197"
        >
            <stop stopColor="#fded7f" offset="0"/>
            <stop stopColor="#504c29" offset="1"/>
        </linearGradient>
        <linearGradient
            id="Gradient_YELLOW_T3b"
            gradientUnits="userSpaceOnUse"
            x1="54.766"
            y1="-41.336"
            x2="226.371"
            y2="206.617"
        >
            <stop stopColor="#c4b962" offset="0"/>
            <stop stopColor="#e1d370" offset="0.0856"/>
            <stop stopColor="#edde77" offset="0.1371"/>
            <stop stopColor="#fcec7e" offset="0.6974"/>
            <stop stopColor="#f4e57a" offset="0.8478"/>
            <stop stopColor="#e8d974" offset="1"/>
        </linearGradient>
        <g id="Template_YELLOW_T3">
            <path
                d="M239.405,222.067C237.844,226.097,226.683,233.019,209.622,240.916C198.211,246.199,183.007,253.193,166.213,255.384L220.855,223.757L239.405,222.067z"
                fill="url(#Gradient_YELLOW_T3a)"
            />
            <path
                d="M5.250,38.229C5.104,20.912,7.124,2.234,7.124,2.234S17.513,-1.022,54.490,0.328L254.636,14.031C254.636,14.031,249.762,211.719,238.829,222.721C231.949,229.643,220.790,226.125,220.790,226.125S214.254,231.175,204.341,238.135C195.208,244.544,183.465,252.776,165.574,255.611C142.301,259.301,81.257,258.743,38.620,257.801C12.903,257.234,0,247.296,0,247.288S5.396,55.545,5.25,38.229z"
                fill="url(#Gradient_YELLOW_T3b)"
            />
        </g>
        <linearGradient
            id="Gradient_PINK_T3a"
            gradientUnits="userSpaceOnUse"
            x1="199.485"
            y1="229.635"
            x2="204.921"
            y2="244.197"
        >
            <stop stopColor="#ff7ace" offset="0"/>
            <stop stopColor="#51273d" offset="1"/>
        </linearGradient>
        <linearGradient
            id="Gradient_PINK_T3b"
            gradientUnits="userSpaceOnUse"
            x1="54.766"
            y1="-41.336"
            x2="226.371"
            y2="206.617"
        >
            <stop stopColor="#c75f98" offset="0"/>
            <stop stopColor="#e46cb7" offset="0.0856"/>
            <stop stopColor="#f072c2" offset="0.1371"/>
            <stop stopColor="#ff79cd" offset="0.6974"/>
            <stop stopColor="#f776c4" offset="0.8478"/>
            <stop stopColor="#eb6fc0" offset="1"/>
        </linearGradient>
        <g id="Template_PINK_T3">
            <path
                d="M239.405,222.067C237.844,226.097,226.683,233.019,209.622,240.916C198.211,246.199,183.007,253.193,166.213,255.384L220.855,223.757L239.405,222.067z"
                fill="url(#Gradient_PINK_T3a)"
            />
            <path
                d="M5.250,38.229C5.104,20.912,7.124,2.234,7.124,2.234S17.513,-1.022,54.490,0.328L254.636,14.031C254.636,14.031,249.762,211.719,238.829,222.721C231.949,229.643,220.790,226.125,220.790,226.125S214.254,231.175,204.341,238.135C195.208,244.544,183.465,252.776,165.574,255.611C142.301,259.301,81.257,258.743,38.620,257.801C12.903,257.234,0,247.296,0,247.288S5.396,55.545,5.25,38.229z"
                fill="url(#Gradient_PINK_T3b)"
            />
        </g>
        <linearGradient
            id="Gradient_GREEN_T3a"
            gradientUnits="userSpaceOnUse"
            x1="199.485"
            y1="229.635"
            x2="204.921"
            y2="244.197"
        >
            <stop stopColor="#bbe34a" offset="0"/>
            <stop stopColor="#3a4818" offset="1"/>
        </linearGradient>
        <linearGradient
            id="Gradient_GREEN_T3b"
            gradientUnits="userSpaceOnUse"
            x1="54.766"
            y1="-41.336"
            x2="226.371"
            y2="206.617"
        >
            <stop stopColor="#8fb039" offset="0"/>
            <stop stopColor="#a6ca41" offset="0.0856"/>
            <stop stopColor="#afd545" offset="0.1371"/>
            <stop stopColor="#bae249" offset="0.6974"/>
            <stop stopColor="#b3db47" offset="0.8478"/>
            <stop stopColor="#acd043" offset="1"/>
        </linearGradient>
        <g id="Template_GREEN_T3">
            <path
                d="M239.405,222.067C237.844,226.097,226.683,233.019,209.622,240.916C198.211,246.199,183.007,253.193,166.213,255.384L220.855,223.757L239.405,222.067z"
                fill="url(#Gradient_GREEN_T3a)"
            />
            <path
                d="M5.250,38.229C5.104,20.912,7.124,2.234,7.124,2.234S17.513,-1.022,54.490,0.328L254.636,14.031C254.636,14.031,249.762,211.719,238.829,222.721C231.949,229.643,220.790,226.125,220.790,226.125S214.254,231.175,204.341,238.135C195.208,244.544,183.465,252.776,165.574,255.611C142.301,259.301,81.257,258.743,38.620,257.801C12.903,257.234,0,247.296,0,247.288S5.396,55.545,5.25,38.229z"
                fill="url(#Gradient_GREEN_T3b)"
            />
        </g>
        <linearGradient
            id="Gradient_ORANGE_T3a"
            gradientUnits="userSpaceOnUse"
            x1="199.485"
            y1="229.635"
            x2="204.921"
            y2="244.197"
        >
            <stop stopColor="#fba335" offset="0"/>
            <stop stopColor="#4f3512" offset="1"/>
        </linearGradient>
        <linearGradient
            id="Gradient_ORANGE_T3b"
            gradientUnits="userSpaceOnUse"
            x1="54.766"
            y1="-41.336"
            x2="226.371"
            y2="206.617"
        >
            <stop stopColor="#c2802a" offset="0"/>
            <stop stopColor="#df912f" offset="0.0856"/>
            <stop stopColor="#eb9932" offset="0.1371"/>
            <stop stopColor="#faa234" offset="0.6974"/>
            <stop stopColor="#f29e33" offset="0.8478"/>
            <stop stopColor="#e69531" offset="1"/>
        </linearGradient>
        <g id="Template_ORANGE_T3">
            <path
                d="M239.405,222.067C237.844,226.097,226.683,233.019,209.622,240.916C198.211,246.199,183.007,253.193,166.213,255.384L220.855,223.757L239.405,222.067z"
                fill="url(#Gradient_ORANGE_T3a)"
            />
            <path
                d="M5.250,38.229C5.104,20.912,7.124,2.234,7.124,2.234S17.513,-1.022,54.490,0.328L254.636,14.031C254.636,14.031,249.762,211.719,238.829,222.721C231.949,229.643,220.790,226.125,220.790,226.125S214.254,231.175,204.341,238.135C195.208,244.544,183.465,252.776,165.574,255.611C142.301,259.301,81.257,258.743,38.620,257.801C12.903,257.234,0,247.296,0,247.288S5.396,55.545,5.25,38.229z"
                fill="url(#Gradient_ORANGE_T3b)"
            />
        </g>
    </defs>
);

export default NoteDefs;


// WEBPACK FOOTER //
// ./src/components/NoteDefs.tsx